/** User-facing labels for ops plan quantities (concept: plan/actual; UOM: hrs). */

export const OPS_PLAN_LABEL_PLAN_HRS = "Planned (hrs)";
export const OPS_PLAN_LABEL_ACTUAL_HRS = "Actual (hrs)";
export const OPS_PLAN_LABEL_ACTUAL_ENTERED_HRS = "Actual entered (hrs)";
export const OPS_PLAN_LABEL_ACTUAL_EVENTS_HRS = "Actual events (hrs)";
export const OPS_PLAN_LABEL_ACTUAL_TOTAL_HRS = "Actual total (hrs)";
export const OPS_PLAN_SOP_COL_ENTERED_HRS = "Actual entered (hrs)";
export const OPS_PLAN_SOP_COL_EVENTS_HRS = "Actual events (hrs)";
export const OPS_PLAN_SOP_COL_TOTAL_HRS = "Actual total (hrs)";
export const OPS_PLAN_SOP_COL_REVENUE = "Revenue (FY)";
export const OPS_PLAN_SOP_COL_EXPENSES = "Expenses (FY)";
export const OPS_PLAN_SOP_COL_COST_PER_KID_HOUR = "Cost per Kid Hour";
export const OPS_PLAN_SOP_COST_PER_KID_HOUR_TITLE =
  "Expenses ÷ Actual total (hrs)";
export const OPS_PLAN_LABEL_YEAR_PLAN_HRS = "Year Plan (hrs)";
export const OPS_PLAN_LABEL_YTD_PLAN_HRS = "YTD Plan (hrs)";
export const OPS_PLAN_LABEL_YTD_ACTUAL_HRS = "YTD Actual (hrs)";
export const OPS_PLAN_LABEL_ACTUAL_PLAN_PCT = "Actual/Plan %";

export const OPS_PLAN_AOP_PROGRESS_SUBTITLE =
  "Current AOP Progress — Year Plan, YTD Plan, and YTD Actual (entered + events) by program (all values in hrs).";

export const OPS_PLAN_SOP_PLAN_HRS_PLACEHOLDER = "Planned (hrs) *";
export const OPS_PLAN_SOP_ACTUAL_ENTERED_HRS_PLACEHOLDER = "Actual entered (hrs)";

export const OPS_PLAN_SOP_REQUIRED_ALERT =
  "Fiscal Year, Program, and Planned (hrs) are required.";

export const OPS_PLAN_CSV_COLUMN_HINT =
  "Columns: fiscal_year, program, planned_hrs, actual_entered_hrs (optional), revenue (optional), expenses (optional)";

export const OPS_PLAN_SOP_EMPTY_MESSAGE =
  "No SOP data. Use the Strategic Operating Plan tab to add fiscal year, program, and planned (hrs) data.";

export const OPS_PLAN_ACTUAL_EVENTS_TITLE =
  "From closed events with kid hours (entered + record).";

export function formatSopPlanHrsByProgramHint(currentFy) {
  return `SOP planned (hrs) by program for Current FY (${currentFy || "—"})`;
}

export function sopEventActualMapKey(fiscalYear, program) {
  const fy = String(fiscalYear || "").trim();
  const prog = String(program || "").trim() || "—";
  return `${fy}|${prog}`;
}

/** Round hours up to a whole number for Ops Plan Dashboard display. */
export function roundOpsPlanHrsUp(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.ceil(n);
}

/** Format hours with no decimals (rounded up). */
export function formatOpsPlanHrs(value) {
  return roundOpsPlanHrsUp(value).toLocaleString();
}

